export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const IMG = {
  hero: "/images/veauce-hero.jpg",
  veauce: "/images/veauce.jpg",
  vains: "/images/prieure.jpg",
  vains2: "/images/prieure-eglise.jpg",
  window: "https://images.unsplash.com/photo-1710204326042-1f28992414fb?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
  door: "https://images.unsplash.com/photo-1725034474154-b4108c93bd3b?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
  interior: "https://images.unsplash.com/photo-1595841044697-86e94ea53c77?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
  sliding: "https://images.unsplash.com/photo-1771372578232-7c20a006f7b4?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
  shutter: "https://images.unsplash.com/photo-1606077089563-cff5a4f3d3d9?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
  sculptor: "https://images.unsplash.com/photo-1721508490084-1b1de5b230d4?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
  carving: "https://images.unsplash.com/photo-1660796334938-cf0b03be7e6d?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
};

export const AUDIO_URL = "https://upload.wikimedia.org/wikipedia/commons/9/90/Erik_Satie_-_gymnopedies_-_la_1_ere._lent_et_douloureux.ogg";
